import { Box } from "@mui/material";
import React from "react";
import Text from "./text/Text";
import Button from "./button/Button";
import { rotationIcon } from "./images";
import LnAddress from "./setupLnAddress/LnAddress";
import { congratulations, continueTxt, successMsg, close } from "./messages";

function SetUpLnAddressSuccess({
  userName,
  handleClose,
  customClass,
  isFromBrowser,
}) {
  const textSize = isFromBrowser ? 16 : 14;
  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      className={customClass}
      boxSizing="border-box"
    >
      <Box className="setup-ln-address-container">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          padding="20px"
          height={isFromBrowser ? "340px" : "420px"}
          justifyContent="space-between"
          textAlign="center"
        >
          <Box>
            <img src={rotationIcon} height="54px" width="54px" />
            <Text className="default-text mt-16" size={22} font="semibold">
              {congratulations}
            </Text>
            <Text className="grey-text mt-16" size={textSize} font="regular">
              {successMsg}
            </Text>
          </Box>
          <LnAddress
            userName={userName}
            isSuccess={true}
            isFromBrowser={isFromBrowser}
          />
        </Box>
        <Box className={isFromBrowser ? "options-footer-btn" : "footer"}>
          <Button
            fullWidth
            variant="contained"
            className="txt-uppercase"
            label={close}
            onClick={handleClose}
            sx={!isFromBrowser ? { margin: "14px 20px" } : {}}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default SetUpLnAddressSuccess;
